import { sendRequest } from "../../sendRequest";

export const acceptOffer = ({ offerId }) => {
  return sendRequest(
    "patch",
    `/influencer/campaign/offer/accept/${offerId}`
  ).then((res) => res.data);
};
